import React, { useState, useEffect, useRef, useContext, useCallback } from 'react'
// import { useInView } from 'react-intersection-observer'
import { m, LazyMotion, domAnimation } from "framer-motion"
import { MainContext } from "../../context/mainContext"
import { ErrorToast } from './errorToast'
import { imgUrlConverter, actionUrlConverter, alternateUrlConverter } from '../../util/util'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

export const Combo = ( { appData:{storedata}, appData:{customerdata} }) => {

    const ctx = useContext(MainContext)
    const [err, setErr] = useState(null)
    const mascotName = storedata?.schoolStoreHeroBannerData?.mascotName
    const productCatalog = customerdata?.filter(data=>data.contentType === 'ProductCatalog')
    const catalogsQty = storedata?.productCatalogs?.length
    const changeYourSchool = <a className='affiliate-school' href='#'>change your school</a>
    const schoolStoreRingSizer = storedata?.schoolStoreRingSizer?.hasRingSizeBanner
    const ringSizerData = customerdata?.filter(data => data.contentType === "SchoolStoreRingSizer")[0]
    const schoolStoreTryOn = storedata?.schoolStoreTryOn?.tryOnBannerUrl
	const tryOnData = customerdata?.filter(data => data.contentType === "SchoolStoreTryOn")[0]
    const isRingSizer = Boolean(schoolStoreRingSizer && ringSizerData)
    const isTryOn = Boolean(schoolStoreTryOn && tryOnData)

    const contactUs = <a href={`${window.location.protocol}//${window.location.hostname}/apps/shop/help/shared/customer_care_index.asp`}>contact us</a>

    let comboCase
    switch (catalogsQty) {
        case 1:
            if (isTryOn && isRingSizer) {
                comboCase = 12
            } else {
                comboCase = 11
            }
            break;
        case 2:
            if (isTryOn && isRingSizer) {
                comboCase = 22
            } else {
                comboCase = 21
            }
            break;
        default:
            break;
    }

    const itemsClassName = catalogsQty === 1 ? ` categories-1 cards-${isTryOn && isRingSizer ? '2' : '1'}` : ` categories-2 cards-${isTryOn && isRingSizer ? '2' : '1'}`

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('error') && urlParams.get('error') === 'true') {
            switch (urlParams.get('errorFile')) {
                case 'no-product-error-specific.htm':
                    setErr({
                        case:1,
                        message: urlParams.get('errorProductName') 
                                ? <span>{urlParams.get('errorProductName')} are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                                : <span>Selected products are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-product-error.htm':
                    setErr({
                        case:2,
                        message: <span>Product is currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-group-error-specific.htm':
                    setErr({
                        case:3,
                        message: urlParams.get('errorGroupName') 
                                ? <span>{urlParams.get('errorGroupName')} are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                                : <span>Selected catalogs are currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-group-error.htm':
                    setErr({
                        case:4,
                        message: <span>Product collection is currently not available to purchase online. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case null:
                    setErr({
                        case:6,
                        message: <span>Our website encountered an unexpected error.We apologize for the inconvenience. Check to make sure you're at the right school. You can {changeYourSchool}, browse the products below, or {contactUs} for additional support.</span>
                    })
                    break;

                case 'inaccessible-product-error.htm':
                    setErr({
                        case:7,
                        message: <span>That item is inaccessible.Please sign in as the original owner of that item.</span>
                    })
                    break;

                case 'no-catalog-products-error.htm':
                    setErr({
                        case:8,
                        message: <span>Actual message: The product you looked for is not currently available for this school. Please {contactUs} for product availability and ordering information.</span>
                    })
                    break;

                case 'no-customer-found.htm':
                    setErr({
                        case:9,
                        message: <span>Actual Message: Your school or group could not be found.We apologize for the inconvenience. Check to make sure you're at the right school. You can {changeYourSchool}, browse the products below, or {contactUs} for additional support.</span>
                    })
                    break;    
    
                default:
                    break;
            }
        }
        if (!storedata?.productCatalogs || storedata?.productCatalogs?.length === 0) {
            const affilate = document.cookie.replace(/(?:(?:^|.*;\s*)affiliateName\s*\=\s*([^;]*).*$)|^.*$/, "$1") + '|' + document.cookie.replace(/(?:(?:^|.*;\s*)affiliateIds\s*\=\s*([^;]*).*$)|^.*$/, "$1")
            const options = {
                method: "POST",
                mode: 'no-cors',
                headers: new Headers({'Content-Type': 'text/plain'}),
                body: 'There are no Jostens catalogs available for ' + affilate
            };

            fetch(actionUrlConverter('https://devwww.jostens.com/apps/store/report.mvc'), options)
            
            setErr({
                case:5,
                message: <span>There are currently no Jostens catalogs available for this school at this time. We apologize for the inconvinience.</span>
            })
        }

        const style = document.createElement("style");
        document.head.appendChild(style);
        style.sheet.insertRule('.slick-disabled{display:none !important;}', 0);

        const activeCards = document.querySelectorAll('.slick-active')
        Array.from(activeCards).forEach(el => {
            el.setAttribute("tabindex","0");
        });

    }, [])

    const showXlDots = (catalogsQty > 5);
    const showLgDots = (catalogsQty > 4);
    const showMdDots = (catalogsQty > 3);
    const showSmDots = (catalogsQty > 2);
    let settings = {
        accessibility: false,
        slidesToShow: catalogsQty === 2 ? 2 : 1,
        slidesToScroll: catalogsQty === 2 ? 2 : 1,
        arrows: false,
        dots: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    variableWidth: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: showMdDots,
                    arrows: false,
                    variableWidth: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: catalogsQty,
                    slidesToScroll: catalogsQty,
                    dots: showMdDots,
                    arrows: false,
                    variableWidth: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: catalogsQty,
                    slidesToScroll: catalogsQty,
                    dots: showLgDots,
                    arrows: false,
                    variableWidth: false
                }
            }
            ,
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: catalogsQty,
                    slidesToScroll: catalogsQty,
                    dots: showXlDots,
                    arrows: false,
                    variableWidth: false
                }
            }
        ]
    }

    const imgHandler = useCallback(
        (catOsr) => {
            let url
            if (productCatalog[0]?.images) {
                const cat = productCatalog[0].images.find(el => el.catalogOsr === catOsr)
                url = cat?.imageUrl
            }
            return url
        },
        [productCatalog]
    )

    const container = {
        show: {
          transition: {
            staggerChildren: 0.2
          }
        }
    }

    const product = {
        hidden: { opacity: 0 },
        show: 
            { 
                opacity: 1,
                transition: {
                    duration: 0.25
                }
            }
    }

    const cardClickHandler = useCallback(
        (e, catalog) => {
            e.stopPropagation()
            if (catalog.subCatalogs?.length) {
                ctx.openPopup({
                    class: 'small',
                    title: 'Select Your Collection',
                    content:<div className="list-group">
                                {
                                    catalog.subCatalogs.map( cat => <a key={cat.id} className="list-group-item" href={actionUrlConverter(cat.actionUrl)}><span>{cat.displayName}</span></a> )
                                }
                            </div>
                })
            } else {
                catalog.alternateUrl ? window.open(alternateUrlConverter(catalog.alternateUrl), '_blank', 'noopener,noreferrer') : window.open(actionUrlConverter(catalog.actionUrl), '_self')
            }
        },
        [],
    )
    const cardKeyPressHandler = useCallback(
        (e, catalog) => {
            console.log(e);
            if(e.key === 'Enter' || e.key === 'Space'){
                cardClickHandler(e, catalog)
            }
        },
        [],
    )

    const Cards = useCallback(
        () => <>
                { isRingSizer && 
                    <m.div 
                        className="item"
                        variants={product}
                    >
                        <div className="img-wrapper">
                            <div className="bg"></div>
                            <img src={imgUrlConverter(ringSizerData.imageUrl)} alt={ringSizerData.imageAltText} loading="lazy" />
                        </div>
                        <div className="content">
                            <h4>{ringSizerData.title}</h4>
                            <div className="text" dangerouslySetInnerHTML={{__html: ringSizerData.content}}></div>
                            <div><a href={ringSizerData.documentUrl} target="_blank" className="btn btn-primary btn-primary--ghost" rel="noopener noreferrer">Download PDF</a></div>
                        </div>
                    </m.div>
                }
                { isTryOn && 
                    <m.div 
                        className="item"
                        variants={product}
                    >
                        <div className="img-wrapper">
                            <div className="bg"></div>
                            <img src={imgUrlConverter(tryOnData.imageUrl)} alt={ringSizerData.imageAltText} loading="lazy" />
                        </div>
                        <div className="content">
                            <h4>{tryOnData.title}</h4>
                            <div className="text" dangerouslySetInnerHTML={{__html: tryOnData.content}}></div>
                            <div><a href={storedata.schoolStoreTryOn.tryOnBannerUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-primary--ghost">Try Now</a></div>
                        </div>
                    </m.div>
                }
            </>,
        [ringSizerData, tryOnData],
    )

    const Cats = useCallback(
        () => <div className="container">
                {
                    catalogsQty === 1 
                    ?
                    <div className="carousel">
                        {storedata.productCatalogs.map((catalog, key) => 
                            <m.div
                                className="item"
                                style={{cursor: 'pointer'}}
                                onClick={(e)=>{cardClickHandler(e, catalog)}}
                                onKeyPress={(e)=>{cardKeyPressHandler(e, catalog)}}
                                key={`CatalogItem-${key}`}
                                variants={product}
                                tabIndex='0'
                            >
                                <div className="img">
                                    <img src={imgHandler(catalog.catalogOsr) ? imgUrlConverter(imgHandler(catalog.catalogOsr)) : imgUrlConverter(catalog.imageUrl)} alt={catalog.displayName} />
                                </div>
                                <div className="overlay">
                                    <div className="inner">
                                        <h3>{catalog.displayName}</h3>
                                        <div className="btn btn-sm btn-white btn-white--ghost">Shop</div>
                                    </div>
                                </div>
                            </m.div>
                        )}
                    </div>
                    :
                    <Slider {...settings} className="carousel">
                        {storedata.productCatalogs.map((catalog, key) => 
                            <m.div
                                className="item"
                                style={{cursor: 'pointer'}}
                                onClick={(e)=>{cardClickHandler(e, catalog)}}
                                onKeyPress={(e)=>{cardKeyPressHandler(e, catalog)}}
                                key={`CatalogItem-${key}`}
                                variants={product}
                            >
                                <div className="img">
                                    <img src={imgHandler(catalog.catalogOsr) ? imgUrlConverter(imgHandler(catalog.catalogOsr)) : imgUrlConverter(catalog.imageUrl)} alt={catalog.displayName} />
                                </div>
                                <div className="overlay">
                                    <div className="inner">
                                        <h3>{catalog.displayName}</h3>
                                        <div className="btn btn-sm btn-white btn-white--ghost">Shop</div>
                                    </div>
                                </div>
                            </m.div>
                        )}
                    </Slider>
                }
            </div>,
        [storedata.productCatalogs]
    )
	return (
        <LazyMotion features={domAnimation}>
            <div 
                className={'container combo' + itemsClassName} 
                // ref={ref}
            >
                <m.div  
                    // ref={slickRef}
                    className="container"
                    variants={container}
                    initial="hidden"
                    animate="show"
                >
                    { mascotName && storedata ? <h2>SHOW YOUR {mascotName} PRIDE</h2> : storedata ? <h2>SHOW YOUR PRIDE</h2> : null}
                    { err ? <ErrorToast message={err.message} /> : null}
                        <div className='row'>
                            { comboCase === 11 &&
                                <>
                                    <div className="col-xs-12 col-xl-7 product-categories-col">
                                        <div className="product-categories items-1">
                                            <Cats />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-xl-5 card-section-col">
                                        <div className="card-section items-1">
                                            <Cards />
                                        </div>
                                    </div>
                                </>
                            }
                            { comboCase === 12 &&
                                <>
                                    <div className="col-xs-12 col-xl-6 product-categories-col">
                                        <div className="product-categories items-1">
                                            <Cats />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-xl-6 card-section-col">
                                        <div className="card-section items-2">
                                            <Cards />
                                        </div>
                                    </div>
                                </>
                            }
                            { comboCase === 21 &&
                                <>
                                    <div className="col-xs-12 col-xl-7 col-xxl-8 product-categories-col">
                                        <div className="product-categories items-2">
                                            <Cats />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-xl-5 col-xxl-4 card-section-col">
                                        <div className="card-section items-1">
                                            <Cards />
                                        </div>
                                    </div>
                                </>
                            }
                            { comboCase === 22 &&
                                <>
                                    <div className="col-xs-12 col-xl-6 product-categories-col">
                                        <div className="product-categories items-2">
                                            <Cats />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-xl-6 card-section-col">
                                        <div className="card-section items-2">
                                            <Cards />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                </m.div>
            </div>
        </LazyMotion>
	)
}

export default Combo